import { useContext } from 'react'
import { LocaleContext } from "../../context/context"

export const useLocale = () => {
    const { locale } = useContext(LocaleContext)
    return locale
}